import debounce from 'lodash/debounce'
import { DEFAULT_DEBOUNCE } from '../../../lib/const'
import ClearableSearchInput from '../../common/ClearableSearchInput.jsx'

const SearchBar = ({ onChange, term }) => {
  const handleOnCHange = debounce(
    (value) => onChange(value === '' ? null : value),
    DEFAULT_DEBOUNCE,
  )

  return (
    <div className="grid-search-bar">
      <div>
        <form onSubmit={(event) => event.preventDefault()} className="search w-form">
          <input type="button" value="." className="search-button w-button" disabled />
          <ClearableSearchInput
            className="input w-input"
            maxLength="256"
            defaultValue={term}
            name="query"
            placeholder="Search by Order Name or Status..."
            id="search"
            required=""
            onValueChange={handleOnCHange}
          />
        </form>
      </div>
    </div>
  )
}

export default SearchBar
